<script lang="ts" setup>
import { UserAnimationEnabled } from "~/states/animation";
import video from "@/assets/videos/cancellationRequest/Сonnection terminated.mp4";
import image from "@/assets/img/cancellationRequest/Сonnection terminated.png";
const animation = UserAnimationEnabled();
const typeForm = `${import.meta.env.VITE_CANCELLATION_TYPEFORM}`;
const contactEmail = import.meta.env.VITE_CONTACT_EMAIL;
const contactPhone = import.meta.env.VITE_CONTACT_PHONE;
const redirectToTypeForm = () => {
  window.open(typeForm, "_blank");
};
</script>
<template>
  <section>
    <div class="main">
      <div class="left">
        <div class="contact-direct" style="text-align: center; margin: 4rem 0">
          <p class="paragraph">
            {{ $t("cancellationRequest.section2.paragraph") }}
          </p>

          <div class="buttons">
            <button
              class="purple-button main-button"
              @click="redirectToTypeForm"
            >
              {{ $t("cancellationRequest.section2.button") }}
            </button>
            <div class="contact">
              <div class="phone">
                <img
                  src="@/assets/img/custom/phone.svg"
                  :alt="$t('alt.phone_icon')"
                />
                <a
                  :href="`tel:${contactPhone}`"
                  target="_blank"
                  class="paragraph"
                  rel="noopener noreferrer"
                  >{{ contactPhone }}</a
                >
              </div>
              <div class="email">
                <img
                  src="@/assets/img/custom/email.svg"
                  :alt="$t('alt.phone_icon')"
                />
                <a
                  :href="`mailto:${contactEmail}`"
                  target="_blank"
                  class="paragraph"
                  rel="noopener noreferrer"
                  >{{ contactEmail }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <CommonVideoWithPlaceholder
          :video-src="video"
          :placeholder="image"
          class-video="video bg"
          class-placeholder="bg img"
          :is-playing="animation"
        />
      </div>
    </div>
  </section>
</template>
<style scoped>
a {
  text-decoration: none;
  color: var(--vt-c-purple);
  font-weight: bold;
}
.main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem 2rem;
  box-sizing: border-box;
  justify-items: center;
  margin-bottom: 4rem;
}

.icon {
  filter: brightness(0) invert(1);
}

.contact,
.phone,
.email {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.contact {
  margin-top: 1.5rem;
  gap: 1.5rem;
}
::v-deep(.bg) {
  width: 100%;
  max-width: 800px;
}
.buttons {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.purple-button,
.white-button {
  margin: auto;
  background: var(--vt-c-purple) 0% 0% no-repeat;
  font-family: "Gilmer Bold";
  position: relative;
  font-size: clamp(14px, 1.5vw, 22px);
  color: var(--vt-c-white);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 1rem;
  transition: all 0.3s ease;
  border-radius: 50px;
  width: 332px;
  height: 71px;
}

.purple-button:hover {
  cursor: pointer;
  background-color: #441cd0;
  box-shadow: 0 0 90px #441cd0;
}
.white-button {
  border: 1px solid var(--vt-c-purple);
  background-color: transparent;
  color: var(--vt-c-purple);
  padding: unset !important;
}
.white-button:hover {
  cursor: pointer;
  box-shadow: 0 0 90px #441cd0;
}
.left {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 1500px) {
  ::v-deep(.bg) {
    max-width: 600px;
  }
}
@media screen and (max-width: 1200px) {
  .main {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    gap: 0;
  }
  .right {
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 780px) {
  * {
    text-align: center;
  }

  .buttons,
  .contact {
    flex-direction: column;
  }
}
</style>
